export default __webpack_public_path__ + "static/media/Tab1-img.70c22e22.png";